const specs = {
  init(): void {
    this.reorderSpecsTable();
    this.reorderSpecsTableReels();
    this.reorderSpecsTableRods();
    this.setMiscCount();
  },

  reorderSpecsTableRods(): void {
  const table = document.querySelector(
    '.product-specs__table--rods',
  ) as HTMLTableElement | null;
  if (!table) return;

  const headerRow = table.querySelector('thead tr');
  if (!headerRow) return;

  const headers = Array.from(headerRow.querySelectorAll('th')).map(
    (th) => th.textContent?.trim().toLowerCase() || '',
  );

  const modelIndex = headers.findIndex((h) => h === 'model');
  const msrpIndex = headers.findIndex((h) => h === 'msrp');

  if (modelIndex === -1 || msrpIndex === -1) return;

  const rows = table.querySelectorAll('tbody tr');

  rows.forEach((row) => {
    const allCells = Array.from(row.querySelectorAll('td'));

    const modelCell = allCells[modelIndex];
    const msrpCell = allCells[msrpIndex];

    // Remove fixed cells from the DOM
    modelCell.remove();
    if (msrpCell) msrpCell.remove();

    // Remaining cells are dynamic specs
    const dynamicCells = allCells.filter(
      (cell, index) =>
        index !== modelIndex &&
        index !== msrpIndex
    );

    const specMap: Record<string, HTMLTableCellElement> = {};
    dynamicCells.forEach((td) => {
      const key = td.getAttribute('data-spec')?.trim().toLowerCase();
      if (key) {
        specMap[key] = td;
      }
    });

    // Remove all dynamic cells
    dynamicCells.forEach((td) => td.remove());

    // Start rebuilding the row
    row.innerHTML = '';
    row.appendChild(modelCell);  // 1. Model

    // 2. Dynamic specs in header order
    headers.forEach((header) => {
      if (
        header === 'model' ||
        header === 'msrp' ||
        header === 'series name' ||
        header === 'schematics'
      ) return;

      if (specMap[header]) {
        row.appendChild(specMap[header]);
      } else {
        const empty = document.createElement('td');
        empty.textContent = '-';
        row.appendChild(empty);
      }
    });

    // 3. MSRP
    if (msrpCell) {
      row.appendChild(msrpCell);
    } else {
      const emptyMsrp = document.createElement('td');
      emptyMsrp.textContent = '-';
      row.appendChild(emptyMsrp);
    }
  });

  // === Reorder HEADER ===
  const headerCells = Array.from(headerRow.querySelectorAll('th'));
  const modelTh = headerCells[modelIndex];
  const msrpTh = headerCells[msrpIndex];

  if (modelTh && msrpTh) {
    modelTh.remove();
    msrpTh.remove();

    headerRow.innerHTML = '';
    headerRow.appendChild(modelTh);  // 1. Model

    // 2. Dynamic spec headers
    headerCells.forEach((th) => {
      const label = th.textContent?.trim().toLowerCase();
      if (
        label &&
        label !== 'model' &&
        label !== 'msrp' &&
        label !== 'series name' &&
        label !== 'schematics'
      ) {
        headerRow.appendChild(th);
      }
    });

    // 3. MSRP
    headerRow.appendChild(msrpTh);
  }
},

reorderSpecsTable(): void {
  const table = document.querySelector(
    '.product-specs__table--default',
  ) as HTMLTableElement | null;
  if (!table) return;

  const headerRow = table.querySelector('thead tr');
  if (!headerRow) return;

  // === STEP 1: Remove columns with data-hide-series or data-hide-schematics ===

  const headerCells = Array.from(headerRow.querySelectorAll('th'));
  const columnIndexesToRemove: number[] = [];

  headerCells.forEach((th, index) => {
    const hideSeries = th.getAttribute('data-hide-series');
    const hideSchematics = th.getAttribute('data-hide-schematics');

    if (hideSeries === 'y' || hideSchematics === 'y') {
      columnIndexesToRemove.push(index);
      th.remove(); // Remove the <th> cell from header
    }
  });

  // Remove matching <td> cells from each body row
  const bodyRows = table.querySelectorAll('tbody tr');
  bodyRows.forEach((row) => {
    const cells = Array.from(row.querySelectorAll('td'));
    columnIndexesToRemove.forEach((colIndex) => {
      if (cells[colIndex]) {
        cells[colIndex].remove();
      }
    });
  });

  // === STEP 2: Continue with existing reordering logic ===

  const headers = Array.from(headerRow.querySelectorAll('th')).map(
    (th) => th.textContent?.trim().toLowerCase() || '',
  );

  const seriesIndex = headers.findIndex((h) => h === 'series name');
  const modelIndex = headers.findIndex((h) => h === 'model');
  const msrpIndex = headers.findIndex((h) => h === 'msrp');
  const schematicIndex = headers.findIndex((h) => h === 'schematics');

  if (modelIndex === -1 || msrpIndex === -1) return;

  const rows = table.querySelectorAll('tbody tr');

  rows.forEach((row) => {
    const allCells = Array.from(row.querySelectorAll('td'));

    const seriesCell = seriesIndex !== -1 ? allCells[seriesIndex] : null;
    const modelCell = allCells[modelIndex];
    const msrpCell = allCells[msrpIndex];
    const schematicCell = schematicIndex !== -1 ? allCells[schematicIndex] : null;

    if (seriesCell) seriesCell.remove();
    modelCell.remove();
    if (msrpCell) msrpCell.remove();
    if (schematicCell) schematicCell.remove();

    const dynamicCells = allCells.filter((cell, index) => {
      return (
        index !== seriesIndex &&
        index !== modelIndex &&
        index !== msrpIndex &&
        index !== schematicIndex
      );
    });

    const specMap: Record<string, HTMLTableCellElement> = {};
    dynamicCells.forEach((td) => {
      const key = td.getAttribute('data-spec')?.trim().toLowerCase();
      if (key) {
        specMap[key] = td;
      }
    });

    dynamicCells.forEach((td) => td.remove());

    row.innerHTML = '';

    if (seriesIndex !== -1 && seriesCell) {
      row.appendChild(seriesCell);
    }

    row.appendChild(modelCell);

    headers.forEach((header) => {
      if (
        header === 'series name' ||
        header === 'model' ||
        header === 'msrp' ||
        header === 'schematics'
      )
        return;

      if (specMap[header]) {
        row.appendChild(specMap[header]);
      } else {
        const empty = document.createElement('td');
        empty.textContent = '-';
        row.appendChild(empty);
      }
    });

    row.appendChild(msrpCell ?? (() => {
      const emptyMsrp = document.createElement('td');
      emptyMsrp.textContent = '-';
      return emptyMsrp;
    })());

    if (schematicIndex !== -1 && schematicCell) {
      row.appendChild(schematicCell);
    }
  });

  // === STEP 3: Reorder the header row ===

  const updatedHeaderCells = Array.from(headerRow.querySelectorAll('th'));
  const seriesTh = seriesIndex !== -1 ? updatedHeaderCells[seriesIndex] : null;
  const modelTh = updatedHeaderCells[modelIndex];
  const msrpTh = updatedHeaderCells[msrpIndex];
  const schematicTh = schematicIndex !== -1 ? updatedHeaderCells[schematicIndex] : null;

  if (modelTh && msrpTh) {
    if (seriesTh) seriesTh.remove();
    modelTh.remove();
    msrpTh.remove();
    if (schematicTh) schematicTh.remove();

    headerRow.innerHTML = '';

    if (seriesIndex !== -1 && seriesTh) {
      headerRow.appendChild(seriesTh);
    }

    headerRow.appendChild(modelTh);

    updatedHeaderCells.forEach((th) => {
      const label = th.textContent?.trim().toLowerCase();
      if (
        label &&
        label !== 'series name' &&
        label !== 'model' &&
        label !== 'msrp' &&
        label !== 'schematics'
      ) {
        headerRow.appendChild(th);
      }
    });

    headerRow.appendChild(msrpTh);
    if (schematicIndex !== -1 && schematicTh) {
      headerRow.appendChild(schematicTh);
    }
  }
},



reorderSpecsTableReels(): void {
  const table = document.querySelector(
    '.product-specs__table--reels',
  ) as HTMLTableElement | null;
  if (!table) return;

  const thead = table.querySelector('thead');
  const headerCells = Array.from(thead?.querySelectorAll('th') || []);
  const bodyRows = table.querySelectorAll('tbody tr');




  const modelHeader = headerCells[0];
  const rrpHeader = headerCells[1];
  const schematicHeader = headerCells[2];
  const specHeaders = headerCells.slice(3); 

  const newHeaderRow = document.createElement('tr');
  newHeaderRow.appendChild(modelHeader);              
  specHeaders.forEach((th) => newHeaderRow.appendChild(th));
  newHeaderRow.appendChild(rrpHeader);                
  newHeaderRow.appendChild(schematicHeader);      

  if (thead) {
    thead.innerHTML = '';
    thead.appendChild(newHeaderRow);
  }



  bodyRows.forEach((row) => {
    const allCells = Array.from(row.querySelectorAll('td'));
    const modelCell = allCells[0];
    const rrpCell = allCells[1];
    const schematicCell = allCells[2];
    const specCells = allCells.slice(3);


    const specMap: Record<string, HTMLTableCellElement> = {};
    specCells.forEach((td) => {
      const key = td.getAttribute('data-spec')?.trim().toLowerCase();
      if (key) {
        specMap[key] = td;
      }
    });


    allCells.forEach((td) => td.remove());

    row.appendChild(modelCell);

  
    specHeaders.forEach((th) => {
      const key = th.textContent?.trim().toLowerCase() || '';
      if (specMap[key]) {
        row.appendChild(specMap[key]);
      } else {
        const empty = document.createElement('td');
        empty.textContent = '-';
        row.appendChild(empty);
      }
    });


    row.appendChild(rrpCell);
    row.appendChild(schematicCell);
  });
},



setMiscCount(): void {
const specsTable = document.getElementById('specs'); 
const specsLink = document.getElementById('jsSpecsLink');
const countRows = document.querySelectorAll('.jsCountRows');
const hasY = Array.from(countRows).some(row => row.getAttribute('data-misc-count') === 'y');

if (hasY) {
   specsTable?.classList.remove('product-specs--remove-table');
   specsLink?.classList.add('d-block');
} else {
   specsLink?.classList.add('d-none');
   specsTable?.classList.add('product-specs--remove-table');
}

}



}

export default specs;
